/** @jsxImportSource @emotion/react */
import ReactDOM from "react-dom/client";

import { GlobalStyles } from "./components/GlobalStyles";

import { UserProvider } from "context/UserContext";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { setAssetPath } from "@esri/calcite-components";
import { defineCustomElements } from "@esri/calcite-components/dist/loader";
setAssetPath(process.env.REACT_APP_ASSET_PATH ?? window.location.href);
defineCustomElements(window, {
  resourcesUrl: process.env.REACT_APP_PUBLIC_URL,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <UserProvider>
    <GlobalStyles />
    <App />
  </UserProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
